import { get, post, put } from "./api";

export const getRefrigerators = (id) => get("/refrigerators/" + id);
export const createRefrigerator = (data) => post("/refrigerators", data);
export const updateRefrigerator = (id, data) =>
    put(`/refrigerators/${id}`, data);
